<template>
  <div>
    <div class="end-alone-container">
      <div class="logo-container">
        <div class="go-back-bt" @click="goBack">返回</div>
        <img
          src="https://jhd-o1.oss-cn-hangzhou.aliyuncs.com/project/lianghui/assets/introduction/logo.png"
          alt=""
          class="logo"
        />
      </div>

      <div class="word-container">
        <div class="text-container" v-if="!isWords">
          <div class="part">回首十三五</div>
          <div class="part">展望十四五</div>
        </div>
        <img :src="leaderWordImg" class="leader-word-img" alt="" />
      </div>

      <div class="content-container">
        <img
          src="https://jhd-o1.oss-cn-hangzhou.aliyuncs.com/project/lianghui/assets/detail-2/yinhao.png"
          class="yinhao-1"
          alt=""
        />
        {{ leaderMsg }}
        <img
          src="https://jhd-o1.oss-cn-hangzhou.aliyuncs.com/project/lianghui/assets/detail-2/yinhao.png"
          class="yinhao-2"
          alt=""
        />
      </div>

      <div class="sign-container">
        <div class="text">{{ leaderTitle }}</div>
        <div class="sign-img-conatainer">
          <img
            :src="leaderSign"
            alt=""
            class="sign-img"
            :class="{
              'move-down': leaderTitle === '南京市委书记',
              'move-down-small':
                leaderTitle === '无锡市委书记' ||
                leaderTitle === '宿迁市委书记',
            }"
          />
        </div>
      </div>

      <div class="leader-contaienr">
        <img
          src="https://jcdn.xhby.net/project/lianghui/new-assets/end/copy-right-bt.png"
          class="banquan-bt"
          alt=""
          @click="isShowCopyRight = true"
        />
      </div>
    </div>

    <div class="mask" v-if="isShowCopyRight">
      <div class="copy-right-out-container">
        <CopyRight class="copy-right-inner-container" />
        <div class="close-container">
          <img
            src="https://jcdn.xhby.net/project/xiaokang/assets/detail/close.png"
            alt=""
            class="close-img"
            @click="isShowCopyRight = false"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { areaInfoList } from "../data";
import CopyRight from "../components/copyright.vue";

export default {
  components: { CopyRight },
  data() {
    return {
      leaderTitle: "",
      leaderMsg: "",
      leaderSign: "",
      leaderWordImg: "",
      isWords: false,

      isShowCopyRight: false,
    };
  },
  mounted() {
    const where = this.$route.params.where;
    const info = areaInfoList[where];
    this.leaderTitle = info.leaderTitle;
    this.leaderMsg = info.leaderMsg;
    this.leaderSign = info.leaderSign;
    this.leaderWordImg = info.aloneImg;
    this.isWords = info.isWords;
  },
  methods: {
    goBack() {
      this.$router.replace(`/thirteen-city?city=${this.$route.params.where}`);
    },
  },
};
</script>

<style scoped>
.end-alone-container {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  /* overflow: auto; */
}

.logo-container {
  display: flex;
  align-items: flex-end;
}

.logo {
  margin-right: 4vw;
  margin-left: auto;
  display: block;
  width: 20vw;
}

.leader-contaienr {
  width: 100%;
  flex-shrink: 0;
  color: #ffde98;
  font-size: 14px;
  font-family: FZZH;
  line-height: 26px;
  overflow: auto;
  margin-bottom: 20px;
  flex: 1;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  /* min-height: 40px; */
  /* flex-shrink: 0; */
}

.banquan-bt {
  width: 32vw;
  cursor: pointer;
  position: relative;
  left: 4vw;
}

.word-container {
  width: 100%;
  margin: 22px auto 0;
}

.text-container {
  display: flex;
  padding: 0 6vw;
  margin-bottom: 6px;
}

.part {
  flex: 1;
  color: #ffde98;
  font-size: 16px;
  text-align: center;
}

.leader-word-img {
  width: 100%;
}

.content-container {
  width: calc(100% - 64px);
  margin: 42px auto 0;
  padding: 27px 22px 25px 26px;
  background: rgba(123, 0, 0, 0.6);
  font-size: 4.8vw;
  line-height: 7vw;
  font-family: FZZH;
  color: #ffde98;
  text-shadow: 0px 3px 12px rgba(93, 3, 0, 0.46);
  position: relative;
  text-align: justify;
  margin-bottom: 70px;
}

.yinhao-1 {
  position: absolute;
  left: 30px;
  width: 7.2vw;
  top: 0;
  transform: translateY(-50%);
}

.yinhao-2 {
  position: absolute;
  right: 30px;
  width: 7.2vw;
  bottom: 0;
  transform: rotate(180deg) translateY(-50%);
}

.logos-line {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}

.xinhua-logo {
  height: 27px;
  margin-right: 20px;
}

.jiaohuidian-logo {
  height: 22px;
}

@media screen and (min-width: 640px) {
  .logo {
    margin-right: 40px;
    margin-left: auto;
    display: block;
    width: 128px;
  }

  .content-container {
    font-size: 20px;
    line-height: 26px;
  }

  .yinhao-1 {
    width: 46px;
  }

  .yinhao-2 {
    width: 46px;
  }

  .text-container {
    padding: 0 38px;
  }

  .banquan-bt {
    width: 200px;
    margin-left: 100px;
    cursor: pointer;
    left: 0;
  }
}

.sign-container {
  display: flex;
  font-size: 14x;
  font-family: FZZH;
  color: #ffde98;
  line-height: 24px;
  padding-right: 32px;
  margin-bottom: 30px;
}

@media screen and (max-height: 700px) {
  .sign-container {
    margin-bottom: 20px;
  }

  .content-container {
    margin-bottom: 50px;
  }

  .content-container {
    width: calc(100% - 64px);
    margin: 22px auto 0;
    padding: 27px 22px 25px 26px;
    background: rgba(123, 0, 0, 0.6);
    font-size: 4.8vw;
    line-height: 7vw;
    font-family: FZZH;
    color: #ffde98;
    text-shadow: 0px 3px 12px rgba(93, 3, 0, 0.46);
    position: relative;
    text-align: justify;
    margin-bottom: 70px;
  }
}

.text {
  margin-right: 14px;
  font-size: 20px;
  margin-left: auto;
  position: relative;
  top: 2px;
}

.sign-img-conatainer {
  width: 100px;
  border-bottom: 1px solid #ffde98;
  position: relative;
}
.sign-img-conatainer-no-border {
  border-bottom: none;
}

.sign-img {
  position: absolute;
  left: 4px;
  width: 24vw;
  bottom: 2px;
}

.move-down {
  bottom: -5vw;
}

.move-down-small {
  bottom: 0;
  width: 22vw;
}

.go-back-bt {
  width: 61px;
  height: 22px;
  background: #ffde98;
  box-shadow: 0px 3px 17px 0px rgba(146, 5, 0, 0.46);
  border-radius: 11px;

  font-size: 15px;
  color: #990100;
  line-height: 22px;
  text-align: center;
  margin-left: 7vw;
}

.mask {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: url("https://jcdn.xhby.net/project/lianghui/new-assets/end-alone/shallow.png");
  background-size: 100% 100%;
  animation: aaa 0.4s;
}

.copy-right-out-container {
  width: 85vw;
  height: 70vh;
  overflow: hidden;
  padding: 20px;
  background: #7b0000;
  margin-bottom: 5vh;
  display: flex;
  flex-direction: column;
}

.copy-right-inner-container {
  flex: 1;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: auto;
}

.close-container {
  padding: 40px;
  display: flex;
  justify-content: center;
  flex-shrink: 0;
}

.close-img {
  width: 9vw;
  height: 9vw;
}

@media screen and (min-width: 640px) {
  .close-img {
    width: 60px;
    height: 60px;
    cursor: pointer;
  }

  .copy-right-out-container {
    width: 500px;
    height: 70vh;
    overflow: hidden;
    padding: 20px;
    background: #7b0000;
    margin-bottom: 5vh;
    display: flex;
    flex-direction: column;
  }

  .sign-img {
    width: 100px;
  }
}

@keyframes aaa {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}
</style>